import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown, ChevronUp, HelpCircle, X } from 'lucide-react';

const FAQModal = ({ isOpen, onClose }) => {
  const { language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = language === 'he' ? [
    {
      question: 'כמה זמן נמשך אימון?',
      answer: 'פגישת אימון מתקיימת אחת לשבוע כ-60 דק׳ ביום ושעה קבועים.'
    },
    {
      question: 'מה בדיוק עושים באימון סאטי?',
      answer: 'הרבה.. נושמים. שוהים. משוחחים. מעלים תחושות. מתעניינים. אנחנו מכבדים את מה שקורה בחיינו ואת התחושות והרגשות הלא נעימים שאנחנו חשים ומרגישים.'
    },
    {
      question: 'במה שונה אימון סאטיה מאימונים אחרים?',
      answer: 'אימון סאטי נשען על הפילוסופיה הבודהיסטית והפילוסופיה האקזיסטנציאליסטית עם כלים מעולם האימון המודרני. אנחנו מתרגלים שהייה עם מה שיש ומתרחש במציאות, כאן ועכשיו. עובדים עם תחושות הגוף, הרגשות שעולים והשפה דרכה אנחנו מתארים את המציאות בה אנחנו חיים. ההבדל העיקרי הוא שבסאטיה אנחנו לא מתעסקים במה לעשות (Doing) אלא במי להיות (Being). ההתנהגות והפעולות כבר יגזרו ממי שתבחרו להיות.'
    },
    {
      question: 'אז איך היית מגדיר את העבודה שלך ואת המרחב שאתה יוצר?',
      answer: 'אני פילותרפיסט. העבודה שלי מבוססת על פילותרפיה – תרפיה מבוססת פילוסופיה (בניגוד לטיפול פסיכולוגי קליני). אמנם אני מביא איתי רקע אקדמי של MBA עם התמחות בפסיכולוגיה עסקית וארגונית, אך כפילותרפיסט בשיטת סאטיה, המיקוד שלי הוא בליווי אנושי דרך חקירה פילוסופית עמוקה של הוויית האדם (Being). זהו מרחב שבו אנחנו לומדים להכיר את עצמנו, את השפה שלנו ואת הגוף שלנו, כדי ליצור טרנספורמציה אמיתית בחיי היומיום. האימון מתבצע במרחב הפרטי שלנו והיישום שלו בחיים עצמם בין המפגשים ולאחר שהתהליך הושלם.'
    },
    {
      question: 'למה אתה קורא לזה "אימון" ולא טיפול?',
      answer: 'זה נכון שהמרחב וההגדרות והאתיקה מאוד מאוד דומים למטפלים. אבל באימון יש אלמנט אקטיבי. כמו בעולם הספורט: ספורטאי מגיע לאימון, יש מבנה מסודר לאימון, תרגול, חזרתיות והכנה לעלייה למגרש. גם באימון סאטי אנחנו נפגשים לאימון שהוא חזרתי. יש מבנה מסודר כהכנה לעלייה למגרש החיים. אנחנו משוחחים על סוגיות מהחיים של המתאמנים כדי שיוכלו בחייהם הפרטיים ליישם את מה שאנחנו מתרגלים בזמן האימון. כמובן ש-60 דק בשבוע לא יהיו מספיקים ולכן צריך ליישם את התרגול בין המפגשים. Practice makes perfect.'
    },
    {
      question: 'מה מפיקים מאימון כזה?',
      answer: `• פיתוח מערכות יחסים מיטיבות, קודם כל עם עצמנו
• היכולת לשהות נינוחים מול אי-נוחות (זו שאנחנו רגילים לזוז ממנה)
• החלפת אשמה באחריות (Accountability) ופיתוח חמלה עצמית
• הגדרת העצמי בהפרדה מנסיבות חיינו
• לנוע קדימה בחיינו ללא משקולות העבר
• היכרות עם מנגנוני ההגנה שלנו והפחדים העמוקים ושחרור האחיזה הרגשית שיש להם בנו
• פיתוח יכולת לנהל שיחות חשובות בצורה נוקבת, כנה, מכבדת וחומלת
• פיתוח סקרנות וחמלה והפחתת שיפוט וביקורת עצמית
• היכרות מעמיקה עם האני הפנימי שלנו וחיבור לרצונות אותנטיים
• מעבר מאדם שהחיים קורים לו לאדם שיוצר את מציאות חייו באחריות ומודעות
• ועוד הרבה..`
    },
    {
      question: 'איפה האימון מתנהל?',
      answer: 'אני מקבל מתאמנים אונליין ויש קליניקה במרכז מדריד, ספרד. אבל כמעט כל המתאמנים שלי מישראל ומהעולם ואנחנו נפגשים בצורה מקוונת.'
    },
    {
      question: 'עבור מי מתאים אימון כזה?',
      answer: `למי שנמצא בצומת דרכים או במשבר:
• מרגישים שהדפוסים האוטומטיים מנהלים אתכם ושחוקים מהניסיון "לתקן" את המצב.
• חווים תקיעות במערכות יחסים, בעבודה או מול תחושות של חוסר ערך ואשמה.
• מרגישים ש"הגיע הזמן לדבר על הדברים" ולהפסיק לטאטא את הכאב מתחת לשטיח.

למי שרוצה לצמוח לרמה הבאה (גם כש"הכל בסדר"):
• שואפים להעמיק את הכנות העצמית ואת רמת המודעות והחופש בחייכם.
• מעוניינים לדייק את הנוכחות (Being) ואת היכולת להנהיג את עצמכם מתוך חמלה.
• רוצים להרחיב את ה"מרווח" שבין הטריגר לתגובה כדי לפעול מתוך בחירה ולא מתוך הרגל.

בשורה התחתונה:
האימון מתאים לכל מי שמוכן לעצור, להקשיב לגוף ולגלות שחופש אמיתי לא מגיע משינוי הנסיבות, אלא מהיכרות עמוקה עם מי שאנחנו מולן.`
    },
    {
      question: 'איך אפשר לעבוד איתי?',
      answer: `שיחת "קלירוואי" (Clearway) – הכנה ממוקדת לאירוע או שיחה:
• הכנה בזמן אמת: פתרון לאירועים מעוררי חשש כמו שיחות שכר, פגישות משפחתיות מתוחות, טיסות, מבחנים או פרוצדורות רפואיות.
• מניעת "השתלטות" הגוף: תרגול שמטרתו להכין את המערכת הגופנית, כדי שהאירוע עצמו לא יהיה הפעם הראשונה שהגוף פוגש את הלחץ ומגיב באוטומט.
• מעבר מהימנעות לעשייה: הופכים שיחה מאימתנית למפגש שבו אתם נוכחים, בהירים ומדויקים.

תהליך עומק והתפתחות (ליווי מתמשך):
• מבנה מסודר: יציאה למסע התפתחותי עמוק ומובנה המאפשר שינוי דפוסים מהשורש.
• התמדה לתוצאות: מומלץ להתמיד לתהליך שנתי, מתוך הבנה שצמיחה אנושית דורשת זמן והטמעה.
• דינמיות ורב-תחומיות: בכל שלב ניתן להתמקד בנושא אחר המעסיק אתכם – זוגיות, הורות, קריירה, כסף, התמודדות עם אובדן או הגשמה אישית.
• דרך חיים: ליווי למי שההתפתחות האישית חשובה לו כערך עליון וכדרך להתנהל בעולם בחופש ובחירה.`
    },
    {
      question: 'סאטיה היא כלי עבודה?',
      answer: 'הכלי הוא בזמן אמת לשאול את עצמי: מה שלומי? מה אני חש? לסרוק את הגוף ולזהות 1-2 תחושות ולתת להן שם ללא שיפוט וביקורת. ובאירוע בו יש חוויה של לחץ, מועקה, פחד, מריבה, ויכוח וכו׳ לעבוד עם הכלי על מנת לווסת את הגוף לפני שאנחנו מגיבים. המרווח בין האירוע לתגובה יתרחב עם הזמן ויעזור לווסת את הגוף ולהחזיר אותו למצב 0 ולבחור באחריות מלאה מי להיות מול הנושא.'
    },
    {
      question: 'מה ההבדל בין תחושה לרגש?',
      answer: 'רגש על פי שיטת סאטיה, היא אוסף של תחושות עם פרשנות סובייקטיבית על המציאות.\nתחושה - היא פיזיולוגית, יחידנית בגוף כמו גרד, חום, זיעה, כיווץ, התרחבות, נימול, כובד וכדומה.\nתחושות מחזיקות בגוף 90 שניות למרות שהן מרגישות לפעמים כמו נצח אבל זו החוויה הסובייקטיבית אל מה שקורה באמת במציאות.'
    }
  ] : [
    {
      question: 'How long is a coaching session?',
      answer: 'A coaching session takes place once a week, about 60 minutes, on a fixed day and time.'
    },
    {
      question: 'What exactly do you do in Satya coaching?',
      answer: 'A lot.. We breathe. We stay present. We talk. We bring up sensations. We get curious. We honor what happens in our lives and the uncomfortable sensations and emotions that we feel.'
    },
    {
      question: 'How is Satya coaching different from other coaching?',
      answer: 'Satya coaching is based on Buddhist philosophy and Existentialist philosophy with tools from the modern coaching world. We practice staying with what is and what is happening in reality, here and now. We work with body sensations, emotions that arise, and the language through which we describe the reality we live in. The main difference is that in Satya we don\'t deal with what to do (Doing) but with who to be (Being). Behavior and actions will derive from who you choose to be.'
    },
    {
      question: 'How would you define your work and the space you create?',
      answer: 'I am a philotherapist. My work is based on philotherapy – philosophy-based therapy (as opposed to clinical psychological treatment). Although I bring an academic background of an MBA with a specialization in Business and Organizational Psychology, as a Satya philotherapist, my focus is on human guidance through deep philosophical inquiry into human Being. This is a space where we learn to know ourselves, our language, and our body, in order to create real transformation in everyday life. The coaching takes place in our private space, and its implementation in life itself between sessions and after the process is complete.'
    },
    {
      question: 'Why do you call it "coaching" and not therapy?',
      answer: 'The space, definitions, and ethics are very similar to therapists. But in coaching there is an active element. Like in sports: an athlete comes to practice, there is a structured training, drills, repetition, and preparation to get on the field. In Satya coaching, we also meet for practice that is repetitive. There is a structured preparation for getting on the field of life. We discuss life issues so that clients can apply what we practice in their private lives. Of course, 60 minutes a week is not enough, so you need to implement the practice between sessions. Practice makes perfect.'
    },
    {
      question: 'What do you gain from such coaching?',
      answer: `• Developing nurturing relationships, first of all with ourselves
• The ability to stay comfortable with discomfort
• Replacing blame with Accountability and developing self-compassion
• Defining the self separately from life circumstances
• Moving forward in life without the weights of the past
• Getting to know our defense mechanisms and deep fears
• Developing the ability to have important conversations in an honest, respectful, and compassionate way
• Developing curiosity and compassion and reducing self-judgment
• Deep acquaintance with our inner self and connection to authentic desires
• Transitioning from a person to whom life happens to a person who creates their reality with responsibility and awareness
• And much more..`
    },
    {
      question: 'Where does the coaching take place?',
      answer: 'I receive clients online and there is a clinic in central Madrid, Spain. But almost all my clients are from Israel and around the world and we meet online.'
    },
    {
      question: 'Who is this coaching for?',
      answer: `For those at a crossroads or in crisis:
• Feeling that automatic patterns are running your life and worn out from trying to "fix" things.
• Experiencing stuckness in relationships, work, or facing feelings of worthlessness and guilt.
• Feeling that "it's time to talk about things" and stop sweeping the pain under the rug.

For those who want to grow to the next level (even when "everything is fine"):
• Aspiring to deepen self-honesty and your level of awareness and freedom.
• Wanting to refine your presence (Being) and ability to lead yourself with compassion.
• Looking to expand the "gap" between trigger and response to act from choice, not habit.

The bottom line:
Coaching is for anyone ready to stop, listen to their body, and discover that true freedom doesn't come from changing circumstances, but from a deep acquaintance with who we are in the face of them.`
    },
    {
      question: 'How can you work with me?',
      answer: `"Clearway" Call – Focused preparation for an event or conversation:
• Real-time preparation: A solution for anxiety-inducing events like salary talks, tense family meetings, flights, exams, or medical procedures.
• Preventing body "takeover": Practice aimed at preparing the physical system, so the event itself won't be the first time the body encounters stress and reacts automatically.
• From avoidance to action: Turning an intimidating conversation into a meeting where you are present, clear, and precise.

In-depth process and development (ongoing guidance):
• Structured approach: Embarking on a deep, structured developmental journey enabling pattern change from the root.
• Persistence for results: A yearly process is recommended, understanding that human growth requires time and integration.
• Dynamic and multidisciplinary: At each stage, you can focus on a different topic – relationships, parenting, career, money, dealing with loss, or personal fulfillment.
• A way of life: Guidance for those who value personal development as a core principle and a way to navigate the world with freedom and choice.`
    },
    {
      question: 'Is Satya a work tool?',
      answer: 'The tool is to ask yourself in real time: How am I? What do I feel? Scan the body and identify 1-2 sensations and name them without judgment or criticism. And in an event where there is an experience of pressure, anxiety, fear, argument, etc., work with the tool to regulate the body before we react. The gap between the event and the response will expand over time and help regulate the body and return it to state 0 and choose with full responsibility who to be.'
    },
    {
      question: 'What is the difference between a sensation and an emotion?',
      answer: 'An emotion, according to the Satya method, is a collection of sensations with a subjective interpretation of reality.\nA sensation is physiological, singular in the body - like itching, heat, sweat, contraction, expansion, tingling, heaviness and so on.\nSensations last in the body for 90 seconds, even though they sometimes feel like an eternity - but that is the subjective experience of what is actually happening in reality.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-start justify-center pt-20 md:pt-24 px-4 pb-8 overflow-y-auto"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
      onClick={onClose}
      data-testid="faq-modal-overlay"
    >
      <div 
        className="relative bg-white rounded-2xl w-full max-w-3xl shadow-2xl animate-fade-in my-4"
        onClick={(e) => e.stopPropagation()}
        data-testid="faq-modal"
      >
        {/* Header */}
        <div 
          className="sticky top-0 flex items-center justify-between p-5 border-b rounded-t-2xl"
          style={{ backgroundColor: 'var(--sand-50)', borderColor: 'var(--sand-200)' }}
        >
          <div className="flex items-center gap-3">
            <HelpCircle size={24} style={{ color: 'var(--sage-600)' }} />
            <h2 
              className="text-2xl"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
            >
              {language === 'he' ? 'שאלות נפוצות' : 'FAQ'}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white rounded-full transition-colors"
            aria-label="Close"
            data-testid="faq-modal-close"
          >
            <X size={24} className="text-gray-500" />
          </button>
        </div>

        {/* FAQ Items */}
        <div className="p-5 space-y-3 max-h-[70vh] overflow-y-auto">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="rounded-xl overflow-hidden transition-shadow hover:shadow-md"
              style={{ backgroundColor: 'var(--sand-50)' }}
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 text-start"
                aria-expanded={openIndex === index}
              >
                <span 
                  className="font-medium text-base flex-1"
                  style={{ color: 'var(--charcoal)' }}
                >
                  {faq.question}
                </span>
                <span 
                  className="flex-shrink-0 ml-4"
                  style={{ color: 'var(--sage-600)' }}
                >
                  {openIndex === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </span>
              </button>
              
              {openIndex === index && (
                <div 
                  className="px-4 pb-4 animate-fade-in"
                  style={{ borderTop: '1px solid var(--sand-200)' }}
                >
                  <p 
                    className="text-gray-600 leading-relaxed pt-3 whitespace-pre-line text-sm"
                  >
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQModal;
